import React, { useEffect, useState } from 'react';

import './SideBarSection.css'


import GeometryShape from './GeometrySection/GeometryShape.js'

import MetricsElemts from './MetricsSection/MetricElemt.js'

import MaterialElemts from './MaterialSection/MaterialElement.js'
import { TbFilterCancel } from "react-icons/tb";
import { TbFilterSearch } from "react-icons/tb";
import { TbDatabaseSearch } from "react-icons/tb";
import { BsTrash3Fill } from "react-icons/bs";
import { TfiReload } from "react-icons/tfi";




export default function SideBarSection({handleGeometryShape, setActions, ClearFilter_geo, setClearFilter_geo, handleMaterial, ListMaterial, handleMetrics, getAllData, handleNumpage, shapeParams }) {


    const [ShowAction, setValueShowAction] =  useState(false)

    const [DisplayButton, setDisplayButton] = useState(false)
    const [collapsed, setCollapsed] = useState(false);

    //const [ClearFilter_geo, setClearFilter_geo] = useState(false)
    





    const setShowAction = (data) => {

        setValueShowAction(data)
        setDisplayButton(true)

    }



    const handleClearFilter = () => {




        setDisplayButton(false); 
        setValueShowAction(false)
        getAllData(1)
        handleNumpage(1)
        handleGeometryShape([])
        setClearFilter_geo(true)

    } 

    const handleBoxSearch = () => {

      setCollapsed(true); 
      
  } 

 
    

    return(

        
        <section className="SideBar">
        <div className="sidebar-inner">
        <div className="sidebar-section">

        <div className='p-style'>

        <div className="icon-wrapper" data-tooltip="Clear Filter">

        <BsTrash3Fill style={{color:'#0056b3', fontSize: '20px'}} className="icon-clear" onClick={handleClearFilter}/>
                 </div>

          <div className="icon-wrapper"  style={{marginLeft:'10%'}} data-tooltip="Search">

            <TbDatabaseSearch style={{color:'#0056b3', fontSize: '20px'}} className="icon-clear" onClick={handleBoxSearch}/>
         </div>

         <div className="icon-wrapper"  style={{marginLeft:'10%'}} data-tooltip="Reload">

            <TfiReload  style={{color:'#0056b3', fontSize: '20px'}} className="icon-clear"  onClick={() => getAllData(1)}/>
         </div>

         </div>
       
        </div>
        <hr className="separator" />
          
          <div className="sidebar-section">
            
            <GeometryShape
              sendGeometryShape={handleGeometryShape}
              setShowAction={setShowAction}
              ClearFilter={ClearFilter_geo}
              setClearFilter_geo={setClearFilter_geo}
              handleNumpage={handleNumpage}
              shapeParams={shapeParams}
            />
          </div>

          <hr className="separator" />
      
          <div className="sidebar-section">
          
            <MetricsElemts 
            handleMetrics={handleMetrics} 
            setShowAction={setShowAction}  
            ClearFilter={ClearFilter_geo}
            setClearFilter_geo={setClearFilter_geo} />
          </div>

          <hr className="separator" />
      
          <div className="sidebar-section">
          
            <MaterialElemts handleMaterial={handleMaterial} 
            ListMaterial={ListMaterial} 
            setShowAction={setShowAction}
            ClearFilter={ClearFilter_geo}
            setClearFilter_geo={setClearFilter_geo}  />
          </div>
      
          {/*ShowAction && DisplayButton ? (
            <div className="sidebar-actions">
              <input
                type="button"
                value="Refine"
                className="btnf include"
                onClick={() => setActions('Include')}
              />
              <input
                type="button"
                value="Exclude"
                className="btnf exclude"
                onClick={() => setActions('Exclude')}
              />
            </div>
          ) : !ShowAction && DisplayButton ? (
            <div className="sidebar-actions">
              <input
                type="button"
                value="Clear Filter"
                className="btnf exclude"
                onClick={handleClearFilter}
              />
            </div>
          ) : null*/}
        </div>

        {collapsed && (
                <div className="modalbox-overlay">
                  <div className="modalbox-content">
                    <button className="modalbox-close" onClick={() => setCollapsed(false)}>
                      &times;
                    </button>

                    <input
                      type="button"
                      value="Refine"
                      className="modalbox-btn include"
                      onClick={() => {setActions('Include'); setCollapsed(false) }}
                    />
                    <input
                      type="button"
                      value="Exclude"
                      className="modalbox-btn exclude"
                      onClick={() => {setActions('Exclude') ; setCollapsed(false)} }
                    />
                  </div>
                </div>
              )}

      </section>
      
     


        
    )




}